/** Parse comma/semicolon recipient lists in the SMTP Settings card. */
export function parseTestRecipients(raw: string): string[] {
  return raw
    .split(/[,;]+/)
    .map((s) => s.trim())
    .filter(Boolean)
}

export function rememberRecipients(
  lastTo: string,
  recent: string[],
  sent: string[],
): { lastTo: string; recent: string[] } {
  const nextRecent = [...sent, ...recent.filter((e) => !sent.includes(e))].slice(0, 12)
  return { lastTo, recent: nextRecent }
}
